import utils from './lib/utils';
import '../vendor/jquery.tablesorter';
import '../vendor/widget-staticRow';
import '../vendor/jquery-browserHistory';
import common from './_common';
import streamingError from './modules/streamingError';
import searchForm from './modules/searchForm';
import { Tooltip } from 'fragments/js/jquery/Tooltip';
import ad from './lib/ad';
common();
streamingError();

$(function() {
    ad.railAd($('.rail-ad'), $('.main-content'), 600);

    if ( $('body').find('[data-tooltip]').length) {
        new Tooltip();
    }

    $('.manufacturer-filter').on('change', function() {
        let val = $(this).val();
        $('.j-price-stock tbody').attr('data-hide', false);
        if (val) {
            $('.j-price-stock tbody:not([data-mfg="' + val + '"])').attr('data-hide', true);
        }
    });

    $('.j-expand-dist').on('click', function(e) {
        let $this = $(this);
        const distId = $(this).closest('tr').data('disti-id');
        let $affectedRows = $(this).closest('tr').siblings('[data-disti-id="' + distId + '"]');
        $affectedRows.toggleClass('hide');
        if ($this.attr('data-view-text')) {
            if ($affectedRows.hasClass('hide')) {
                $this.text($this.attr('data-view-text'));
            } else {
                $this.text($this.attr('data-hide-text'));
            }
        }
    });

    $('.j-more-disti-row').on('click', function(e) {
        const $hidden = $(this).siblings('[data-hide]');
        if ($hidden.eq(0).attr('data-hide') === 'true') {
            $hidden.attr('data-hide', 'false');
        }
        $(this).remove();
        window.setTimeout(function() {
            utils.alignManuImg($hidden);
        }, 100);
    });

    setupFCTable();
    setupDsaTable();
    setupSolrTable();

    $('body').on('click', '.j-ecad-new', function (ev) {
        let $this = $(this);
        let impUrl = $this.attr('data-ecad-imp');
        $(this).append('<img src="' + impUrl + '" style="display: none;" />');
    });
    utils.alignManuImg($('.j-manu-logo img'));

    $(window).resize(function() {
        const isMobile = determineMobile();
        if (!isMobile) {
            $('.j-filter-list').show();
        } else {
            $('.j-filter-list').hide();
            showOrHideResetFilter();
        }
    });

    let widgetObserver = null;
    let updateTablesTimeout = null;
    const widgetsToLoadSelector = '.j-ecad-new:not(:has(script))';
    if (window.DSA.widgetPath && window.DSA.widgetKey) {
        const { widgetKey, widgetPath } = window.DSA;
        widgetObserver = new IntersectionObserver(function (entries, observer) {
            for (const entry of entries) {
                if (!entry.isIntersecting) {
                    continue;
                }

                clearTimeout(updateTablesTimeout);

                const el = entry.target;
                const $el = $(el);

                const ecadId = $el.attr('data-ecad-id');
                const id = encodeURIComponent(ecadId);
                const mfg = encodeURIComponent($el.attr('data-ecad-mfg'));
                const mpn = encodeURIComponent($el.attr('data-ecad-mpn'));
                const script = document.createElement('script');
                script.async = true;
                let srcPath = `${widgetPath}/widget/icon?key=${widgetKey}&partNumber=${mpn}&manufacturer=${mfg}`;

                if (ecadId) {
                    script.id = `ecad-${id}`;
                    srcPath.concat(`&id=ecad-${id}`);
                }

                script.src = srcPath;

                // enforce DOM change only after busy load tasks
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(
                        () => window.requestAnimationFrame(() => el.appendChild(script))
                    );
                } else { // safari: https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback#browser_compatibility
                    window.requestAnimationFrame(() => el.appendChild(script));
                }

                updateTablesTimeout = setTimeout(function() {
                    $('.j-dsa-table').trigger('update');
                    $('.j-top-results').trigger('update');
                }, 3000);

                observer.unobserve(el);
            }
        }, { rootMargin: '0px 0px 150px 0px' });

        for (const el of $(widgetsToLoadSelector)) {
            widgetObserver.observe(el);
        }
    }

    // pagination::start
    $('button[data-page]').on('click', function() {
        if (widgetObserver) {
            widgetObserver.disconnect();
        }

        if (hoverCandidatesSelector) {
            unsetHoverCandidateListeners($(hoverCandidatesSelector));
        }

        const page = Number($(this).attr('data-page'));
        const table = $(this).parent().data('table');
        paginateTable(table, page, function() {
            utils.scrollToEl($('.j-' + table + '-table').parent());
            if (widgetObserver) {
                for (const el of $(widgetsToLoadSelector)) {
                    widgetObserver.observe(el);
                }
            }

            if (rowsToListen > 0 && hoverCandidatesSelector) {
                setHoverCandidateListeners($(hoverCandidatesSelector), rowsToListen);
            }
        });
    });

    $('.j-prev').on('click', function() {
        if (!$(this).hasClass('disabled')) {
            if (widgetObserver) {
                widgetObserver.disconnect();
            }

            if (hoverCandidatesSelector) {
                unsetHoverCandidateListeners($(hoverCandidatesSelector));
            }

            const table = $(this).parent().data('table');
            paginateTable(table, getCurrentPage(table) - 1, function() {
                utils.scrollToEl($('.j-' + table + '-table').parent());
                if (widgetObserver) {
                    for (const el of $(widgetsToLoadSelector)) {
                        widgetObserver.observe(el);
                    }
                }

                if (rowsToListen > 0 && hoverCandidatesSelector) {
                    setHoverCandidateListeners($(hoverCandidatesSelector), rowsToListen);
                }
            });
        }
    });

    $('.j-next').on('click', function() {
        if (!$(this).hasClass('disabled')) {
            if (widgetObserver) {
                widgetObserver.disconnect();
            }

            if (hoverCandidatesSelector) {
                unsetHoverCandidateListeners($(hoverCandidatesSelector));
            }

            const table = $(this).parent().data('table');
            paginateTable(table, getCurrentPage(table) + 1, function() {
                utils.scrollToEl($('.j-' + table + '-table').parent());
                if (widgetObserver) {
                    for (const el of $(widgetsToLoadSelector)) {
                        widgetObserver.observe(el);
                    }
                }

                if (rowsToListen > 0 && hoverCandidatesSelector) {
                    setHoverCandidateListeners($(hoverCandidatesSelector), rowsToListen);
                }
            });
        }
    });
    // pagination::end

    const idBnls = [];
    const hoverCandidatesSelector = '.dsa-table [data-id]:visible';
    const fcsah = window.DSA.sah = {
        triggerLimit: 5,
        timerId: null,
        activeId: null,
        activeType: null,
    };
    let rowsToListen = 20;

    setBnlListeners(idBnls, fcsah, rowsToListen);
    if (idBnls.every(({ id }) => !fcsah[id]?.mfr)) {
        // bnls not rendered yet at document.ready
        const handler = () => setBnlListeners(idBnls, fcsah, rowsToListen);
        idBnls.forEach(({ $el }) => $el.one('mouseenter', handler));
    }

    setHoverCandidateListeners($(hoverCandidatesSelector), rowsToListen);

    function determineMobile() {
        const width = $(window).width();
        let isMobile = true;
        if (width >= 900) {
            isMobile = false;
        }
        $('.j-top-filters').attr('data-is-mobile', isMobile);
        return isMobile;
    }

    function showOrHideResetFilter() {
        const isMobile = $('.j-top-filters').attr('data-is-mobile');
        if (isMobile === 'true') {
            $('.j-top-filters').children('div').slice(2, 4).each(function (idx, el) {
                const $el = $(el);
                const mfg = $el.attr('data-mfg-filter');
                const year = $el.attr('data-year-filter');
                if (mfg || year) {
                    $el.children('.j-filter-list').show();
                }
            });
        }
    }

    function getRateForCode(code) {
        if (!code) {
            return false;
        }
        const $el = $('.j-fc-change-currency option[data-code=' + code + ']');
        return ($el.length === 1) ? Number($el.data('rate')) : false;
    }

    function handleTableSortArrow(e) { // changes the arrow icon in th
        const $table = $(e.currentTarget);
        $table.find('thead th').each(function(idx, el) {
            const $th = $(el);
            const $icon = $th.find('i').removeClass('icon-arrow-up icon-arrow-down');
            if (!$th.hasClass('sorter-false')) {
                if ($th.hasClass('tablesorter-headerAsc')) {
                    $icon.addClass('icon-arrow-up');
                    $icon.removeClass('icon-arrow-up-down icon-arrow-down');
                } else if ($th.hasClass('tablesorter-headerDesc')) {
                    $icon.removeClass('icon-arrow-up-down icon-arrow-up');
                    $icon.addClass('icon-arrow-down');
                } else {
                    $icon.addClass('icon-arrow-up-down'); // unsorted
                }
            }
        });
    }

    function paginateTable(table, page, callback) {
        const term = $('[data-term]').data('term');
        const mfgQuery = $('[data-mfg-filter]').data('mfgFilter');
        const yearQuery = $('[data-year-filter]').data('yearFilter');
        const hCrc = $('meta[name="hcrc"]').attr('value');
        const reqUrl = '/' + window.location.search;

        return $.ajax({
            url: '/ajax/' + table,
            type: 'GET',
            data: {
                term: term ? encodeURIComponent(term) : term,
                page: page,
                mfgQuery: mfgQuery ? encodeURIComponent(mfgQuery) : mfgQuery,
                yearQuery: yearQuery ? encodeURIComponent(yearQuery) : yearQuery,
                reqUrl: reqUrl ? encodeURIComponent(reqUrl) : reqUrl,
                hcrc: hCrc ? encodeURIComponent(hCrc) : hCrc
            },
            success: function(data) {
                if (data.hasError || !$.trim(data.html)) {
                    return;
                }
                const tableSelector = '.j-' + table + '-table';
                $(data.html).insertAfter(tableSelector);
                $(tableSelector).eq(0).remove();

                const qs = (table === 'solr') ? { page: page } : { dsaShowMore: page };
                $.appendQuerystring(qs);

                updatePaginator($('.j-' + table + '-paginator'), page);

                if (table === 'solr') {
                    setupSolrTable();
                } else {
                    setupDsaTable();
                }

                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    }

    function updatePaginator($paginator, targetPage) {
        const totalPages = $paginator.data('total');
        const pages = pagesToDisplay(targetPage, totalPages);
        $paginator.find('button.j-page').each(function(idx, el) {
            const $el = $(el);
            $el.removeClass('paginator-current');
            $el.text(pages[idx]).attr('data-page', pages[idx]);
            if (pages[idx] === targetPage) {
                $el.addClass('paginator-current');
            }
        });
        if (targetPage === 1) {
            $paginator.find('.j-prev').addClass('disabled');
        } else {
            $paginator.find('.j-prev').removeClass('disabled');
        }
        if (targetPage === totalPages) {
            $paginator.find('.j-next').addClass('disabled');
        } else {
            $paginator.find('.j-next').removeClass('disabled');
        }

        function pagesToDisplay(current, total) {
            let pages = [];
            if (total <= 6) {
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
                return pages;
            }
            if (current === total - 3) {
                pages = [current - 2, current - 1, current];
            } else if (current === 1 || (current >= total - 2 && current <= total)) {
                pages = [1, 2, 3];
            } else {
                pages = [current - 1, current, current + 1];
            }
            return pages.concat([total - 2, total -1, total]);
        }
    }

    function getCurrentPage(table) {
        return Number($('.j-' + table + '-paginator button.paginator-current').attr('data-page'));
    }

    function setupDsaTable() {
        $.tablesorter.addParser({
            id: 'ecad',
            is: function () {
                return false;
            },
            format: function (_s, _table, cell, _cellIndex) {
                return parseInt($(cell).find('.j-ecad-new script').siblings().length);
            },
            type: 'numeric'
        });
        $.tablesorter.addParser({
            id: 'normalizedFileSize',
            format: function (_s, _table, cell, _cellIndex) {
                return (Number($(cell).attr('raw')));
            },
            type: 'numeric'
        });
        $('.j-dsa-table').tablesorter({
            sortReset: true,
            headers: {
                '.col-ecad': { sorter: 'ecad' },
                '.col-curated': { sorter: 'curated' },
                3: { sorter: false, parser: false }, // disables sorting on description column
                '.col-pdf-link': { sorter: false, parser: false }, // disables sorting on PDF column
                '.col-pdf-size': { sorter: 'normalizedFileSize' },
            },
            cssInfoBlock: 'j-avoid-sort',
            widgets: ['columns', 'staticRow'],
            initialized: function() {
                $('.j-dsa-table .ad-content iframe').each(function(_i, item) {
                    const $item = $(item);
                    $item.attr('src', $item.attr('data-src'));
                });
            }
        }).on('sortEnd', handleTableSortArrow);
        $('.j-top-results').tablesorter({
            sortReset: true,
            headers: {
                1: { sorter: 'ecad' },
                3: { sorter: false, parser: false }, // disables sorting on description column
                4: { sorter: false, parser: false }, // disables sorting on datasheet column
                5: { sorter: false, parser: false } // disables sorting on Buy column
            },
            widgets: ['columns']
        }).on('sortEnd', handleTableSortArrow);
    }

    function setupSolrTable() {
        $.tablesorter.addParser({ // custom cell parser for solr table
            id: 'solrTableParser',
            is: function() { // used to autodetect parser, we don't need it
                return false;
            },
            format: function(s, table, cell, cellIndex) { // returns the text to sort
                const $cell = $(cell);
                if (cellIndex === 0) { // if cell is catalog datasheet
                    return $cell.find('.j-title').data('title');
                } else if (cellIndex === 1) { // if cell is mfg & type
                    return $cell.find('.j-type').text();
                }
            },
            type: 'text'
        });

        $('.j-solr-table').tablesorter({
            sortReset: true,
            headers: {
                0: { sorter: 'solrTableParser' },
                1: { sorter: 'solrTableParser' },
                2: { sorter: false, parser: false }, // disables sorting on PDF column
                3: { sorter: false, parser: false } // disables sorting on tags column
            },
            widgets: ['staticRow'],
            initialized: function() {
                $('.j-solr-table .ad-content iframe').each(function(_i, item) {
                    const $item = $(item);
                    $item.attr('src', $item.attr('data-src'));
                });
            }
        }).on('sortEnd', handleTableSortArrow);
    }

    function setupFCTable() {
        $.tablesorter.addParser({ // custom cell parser for FC table
            id: 'fcTableParser',
            is: function() { // used to autodetect parser, we don't need it
                return false;
            },
            format: function(s, table, cell, cellIndex) { // returns the text to sort
                const $cell = $(cell);
                if (cellIndex === 3) { // if cell is stock
                    return $cell.parent().data('stock');
                } else if (cellIndex === 4 || cellIndex === 5) { // if cell best or each price
                    const origPrice = Number($cell.data('price'));
                    if (origPrice === 0) {
                        return 0;
                    }

                    const code = $cell.parent().data('code');

                    if (code !== 'USD') {
                        const usdRate = getRateForCode(code);
                        if (usdRate) {
                            return utils.roundWithPrecision((origPrice / usdRate), 4);
                        }
                    }

                    return utils.roundWithPrecision(origPrice, 4);
                }
            },
            type: 'numeric'
        });
    }

    if ($('.not-found .j-search-form').length) {
        searchForm.init($('#notfoundsearch'));
    }

    function setHoverCandidateListeners($hoverCandidates, rowsToListen) {
        for (const el of $hoverCandidates) {
            if (rowsToListen === 0) {
                break;
            }

            const $el = $(el);

            const elDataId = $el.attr('data-id');
            if ($el.attr('data-sa-event-element') === 'logo') {
                fcsah[elDataId] = {
                    triggers: [0, 0, 0],
                    dist: $el.attr('data-distributor_name'),
                };

                $el.on('mouseenter', mouseEnterHandler)
                    .on('mouseleave', mouseLeaveHandler);
                continue;
            }

            fcsah[elDataId] = {
                triggers: [0, 0, 0],
                mfr: $el.attr('data-mfr'),
                pn: $el.attr('data-mfrpartnumber'),
                desc: $el.attr('data-mfrpartdesc'),
                sheetType: $el.attr('data-sheettype'),
                hasEcad: $el.attr('data-parthasecad'),
            };

            $el.find('.j-sa-event')
                .on('mouseenter', mouseEnterHandler)
                .on('mouseleave', mouseLeaveHandler);

            rowsToListen--;
        }
    }

    function unsetHoverCandidateListeners($hoverCandidates) {
        for (const el of $hoverCandidates) {
            const $el = $(el);

            if ($el.attr('data-sa-event-element') === 'logo') {
                $el.off('mouseenter', mouseEnterHandler)
                    .off('mouseleave', mouseLeaveHandler);
                continue;
            }

            $el.find('.j-sa-event')
                .off('mouseenter', mouseEnterHandler)
                .off('mouseleave', mouseLeaveHandler);
        }
    }

    function setBnlListeners(idBnls, fcsah, rowsToListen) {
        if (!Array.isArray(idBnls)) {
            return;
        }

        if (idBnls.every(({ id }) => fcsah[id]?.mfr)) {
            return;
        }

        for (const bnl of idBnls) {
            if (!bnl.$el.length) {
                continue;
            }

            const $row = bnl.$el.find('.row');
            fcsah[bnl.id] = {
                triggers: [0, 0, 0],
                dist: $row.attr('data-distributor_name'),
                mfr: $row.find('.mfrName').text(),
                pn: $row.attr('data-mfrpartnumber'),
                stock: $row.attr('data-instock'),
                price: $row.find('.mfrPrice .table-list').text(),
            };

            const selectors = [
                '.bnl-distributor-logo',
                '.buy-now-click-tracking[data-click-name="part number"]',
                '.buy-now-click-tracking[data-click-name="buy"]',
            ];
            for (const selector of selectors) {
                bnl.$el.find(selector)
                    .on('mouseenter', getBnlMouseEnterHandler(bnl.id))
                    .on('mouseleave', mouseLeaveHandler);
            }

            rowsToListen--;
        }
    }

    function getBnlMouseEnterHandler(bnlId) {
        return function() {
            if (!window.DSA.sah) {
                return;
            }

            const { sah } = window.DSA;
            sah.activeId = bnlId;
            sah.activeType = getHoverElementType($(this));

            mouseEnterHandler();
        };
    }

    const hoverElement = { logo: 0, mpn: 1, bnl: 2 };

    function getHoverElementType($el) {
        if ($el.attr('data-sa-event-element')) {
            return {
                isSponsor: false,
                element: hoverElement[$el.attr('data-sa-event-element')],
            };
        }
        if ($el.hasClass('buy-now-click-tracking')) {
            if ($el.attr('data-click-name') === 'part number') {
                return {
                    isSponsor: true,
                    element: hoverElement.mpn,
                };
            }
            if ($el.attr('data-click-name') === 'buy') {
                return {
                    isSponsor: true,
                    element: hoverElement.bnl,
                };
            }
        }
        if ($el.hasClass('bnl-distributor-logo')) {
            return {
                isSponsor: true,
                element: hoverElement.logo,
            };
        }
        return null;
    }

    function mouseEnterHandler() {
        const { sah } = window.DSA;
        const $this = $(this);
        const hoverId = $this.attr('data-id') ?? $this.attr('data-row-id');
        if (!sah.activeId && hoverId) {
            sah.activeId = hoverId;
            sah.activeType = getHoverElementType($this);
        }

        if (sah[sah.activeId].triggers[sah.activeType.element] < sah.triggerLimit) {
            sah.timerId = window.setInterval(triggerHandler, 3000);
        }
    }

    function mouseLeaveHandler() {
        const { sah } = window.DSA;
        if (!sah) {
            return;
        }

        sah.activeId = null;
        sah.activeType = null;
        const timerId = sah.timerId;
        if (!timerId) {
            return;
        }

        clearInterval(timerId);
        sah.timerId = null;
    }

    function triggerHandler() {
        const { sah } = window.DSA;

        if (!sah.activeId) {
            return;
        }

        const sahActive = sah[sah.activeId];

        if (sahActive.triggers[sah.activeType.element] === sah.triggerLimit) {
            return;
        }

        sahActive.triggers[sah.activeType.element]++;
        const dataLayer = window.dataLayer || [];
        dataLayer.push(getEvent(sahActive, sah.activeType));
    }

    function getEvent(sahActive, activeType) {
        const sponsorPrefix = activeType.isSponsor ? 'sponsor-' : '';
        const type = ['logo', 'mpn', 'pdf-link'][activeType.element];
        const baseEvent = {
            event: 'sa_hover',
            element_type: `${sponsorPrefix}${type}`,
        };

        return {
            ...baseEvent,
            part_number: sahActive.pn,
            manufacturer: sahActive.mfr,
            product_description: sahActive.desc,
            sheet_type: sahActive.sheetType,
            has_ecad: sahActive.hasEcad
        };
    }
});
